
async function clearCart() {
  await fetch('/cart/clear.js', {
    method: 'POST',
  })
}

async function checkIfVariantAlreadyInCart(variantId) {
  const res = await fetch('/cart.js')
  const data = await res.json()
  const existingItems = data.items.filter(el => el.id == variantId)
  return existingItems.length > 0 ? existingItems : false
}

const checkoutBtns = document.querySelectorAll('.horizontal-offer-badge, .cta-button, .circle-badge, .add-to-cart-ajax')

checkoutBtns.forEach(el => {
  el.addEventListener('click', async function () {
    var variId = this.getAttribute('variant-id')
    if(!variId) variId = this.getAttribute('data_id')
    if(variId){
      const existingItems = await checkIfVariantAlreadyInCart(variId)
      // If product variants exist in cart, remove them all first
      if(existingItems) {
        try {
          await clearCart()
        } catch(error) {
          console.error('Error removing product variants from cart:', error);
          // Continue anyway - we'll try to add the new item
        }
      }
      console.log("variId", variId)
      this.classList.add('disabled', 'shimmer')
      // Add item to cart and redirect to checkout
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        if (data.status && data.status === 422) {
          throw new Error(data.description || 'Product could not be added to cart');
        }
        
        // Redirect to checkout
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error('Error:', error);
        alert('There was an error processing your request. Please try again.');
        this.classList.remove('disabled', 'shimmer')
      });
    }
  })
})